import { useQuery, useMutation } from "@tanstack/react-query";
import DataService from "../../../helpers/config/DataService";
import { useCustomToaster } from "../../../hooks/useCustomToaster";
import { queryClient } from "../../../helpers/config/queryClient";

const { getRequest, postRequest } = DataService();

export const useLanding = ({ isTrigger, isMobile, isMobileTrigger }) => {
  const token = localStorage.getItem("token");
  return useQuery({
    queryKey: ["news"],
    queryFn: () => {
      return getRequest(`/news_categories`);
    },
    // enabled: (!!token && (isTrigger || isMobileTrigger)),
    // staleTime: isMobile ? 1500 : 0
  });
};

export const usePostCategory = () => {
  const toaster = useCustomToaster();
  const token = localStorage.getItem("token");
  return useMutation({
    mutationFn: (data) => {
      return postRequest(`/get_news_timeline`, { ...data });
    },
    enabled: !!token,
    onSuccess: (success) => {
      if (!success?.status) {
        toaster.error(success?.message);
      }
    },
  });
};

export const useLike = () => {
  const toaster = useCustomToaster();
  return useMutation({
    mutationFn: (data) => {
      return postRequest(`/like_news`, { ...data });
    },
    onSuccess: (success) => {
      if (!success?.status) {
        toaster.error(success?.message);
      }
    },
    onError: () => {
      toaster.error("Something went wrong");
    },
  });
};

export const useAddPost = () => {
  const toaster = useCustomToaster();
  return useMutation({
    mutationFn: (data) => {
      return postRequest(`/post_community`, data);
    },
    onSuccess: (success) => {
      if (!success?.status) {
        toaster.error(success?.message);
      } else {
        toaster.success(success?.message);
      }
    },
    onError: () => {
      toaster.error("Something went wrong");
    },
  });
};

export const useGetCommunity = ({ limit, page, search, isTrigger, isMobile, isMobileTrigger }) => {
  const token = localStorage.getItem("token");

  return useQuery({
    queryKey: ["community", limit, page, search],
    queryFn: () => {
      return getRequest(
        `/get_community_timeline?search=${search}&limit=${limit}&page=${page}`,
      );
    },
    // enabled: (!!token && (isTrigger || isMobileTrigger)),
    refetchOnMount: true,
    // staleTime: isMobile ? 1500 : 0,
  });
};

export const useManageCommunity = ({ status, limit, page, isTab }) => {
  const token = localStorage.getItem("token");

  return useQuery({
    queryKey: ["manage_community", status, limit, page],
    queryFn: async () => {
      return await getRequest(`/my_community_posts?status=${status}&limit=${limit}&page=${page}`);
    },

    enabled: (!!token && isTab),
    refetchOnMount: true,
    staleTime: 0,
  });
};

export const useManageCommunityDrafts = ({ limit, page, isTab }) => {
  const token = localStorage.getItem("token");

  return useQuery({
    queryKey: ["manage_community"],
    queryFn: async () => {
      return await getRequest(`/my_community_posts`);
    },

    enabled: (!!token && isTab),
    refetchOnMount: true,
    staleTime: 0,
  });
};

export const useGetCommunitycomments = () => {
  const toaster = useCustomToaster();
  return useMutation({
    mutationFn: (data) => {
      return postRequest(`/get_community_comments`, { ...data });
    },
    onSuccess: (success) => {
      if (!success?.status) {
        toaster.error(success?.message);
      }
    },
    onError: () => {
      toaster.error("Something went wrong");
    },
  });
};

export const useCommunityLike = () => {
  const toaster = useCustomToaster();
  return useMutation({
    mutationFn: (data) => {
      return postRequest(`/like_community`, { ...data });
    },
    onSuccess: (success) => {
      if (!success?.status) {
        toaster.error(success?.message);
      }
    },
    onError: () => {
      toaster.error("Something went wrong");
    },
  });
};

export const useCommunityFavLike = () => {
  const toaster = useCustomToaster();
  return useMutation({
    mutationFn: (data) => {
      return postRequest(`/toggle_community_favorite`, { ...data });
    },
    onSuccess: (success) => {
      if (!success?.status) {
        toaster.error(success?.message);
      }
    },
    onError: () => {
      toaster.error("Something went wrong");
    },
  });
};

export const useAddCommunity = () => {
  const toaster = useCustomToaster();
  return useMutation({
    mutationFn: (data) => {
      return postRequest(`/add_community_comment`, { ...data });
    },
    onSuccess: (success) => {
      if (!success?.status) {
        toaster.error(success?.message);
      }
    },
    onError: () => {
      toaster.error("Something went wrong");
    },
  });
};

/* add extra */

export const useGetCommentReplies = () => {
  const token = localStorage.getItem("token");

  return useQuery({
    queryKey: ["community"],
    queryFn: () => {
      return getRequest(`/get_community_timeline`);
    },
    enabled: !!token,

  });
};

/* add extra */

export const useCommunityEdit = () => {
  const toaster = useCustomToaster();
  return useMutation({
    mutationFn: (data) => {
      return postRequest(`/edit_community`, data);
    },
    onSuccess: (success) => {
      if (!success?.status) {
        toaster.error(success?.message);
      }
    },
    onError: () => {
      toaster.error("Something went wrong");
    },
  });
};

export const useCommunityDelete = () => {
  const toaster = useCustomToaster();
  return useMutation({
    mutationFn: (data) => {
      return postRequest(`/delete_community`, { ...data });
    },
    onSuccess: (success) => {
      if (!success?.status) {
        toaster.error(success?.message);
      }
    },
    onError: () => {
      toaster.error("Something went wrong");
    },
  });
};



export const useGetFavourite = ({ limit, page, isTab }) => {
  const token = localStorage.getItem("token");

  return useQuery({
    queryKey: ["favourites", limit, page], // <-- CHANGED from "community" to "favourites"
    queryFn: () => {
      return getRequest(`/my_favourite_posts?limit=${limit}&page=${page}`);
    },
    enabled: (!!token && isTab),
  });
};

export const useEditCommunityComments = () => {
  const toaster = useCustomToaster();
  return useMutation({
    mutationFn: (data) => {
      return postRequest(`/edit_community_comment`, { ...data });
    },
    onSuccess: (success) => {
      if (!success?.status) {
        toaster.error(success?.message);
      }
    },
    onError: () => {
      toaster.error("Something went wrong");
    },
  });
};


export const useDeleteCommunityComments = () => {
  const toaster = useCustomToaster();
  return useMutation({
    mutationFn: (data) => {
      return postRequest(`/delete_community_comment`, { ...data });
    },
    onSuccess: (success) => {
      if (!success?.status) {
        toaster.error(success?.message);
      }
    },
    onError: () => {
      toaster.error("Something went wrong");
    },
  });
};

export const useDeleteNewsComments = () => {
  const toaster = useCustomToaster();
  return useMutation({
    mutationFn: (data) => {
      return postRequest(`/delete_news_comment`, { ...data });
    },
    onSuccess: (success) => {
      if (!success?.status) {
        toaster.error(success?.message);
      }
    },
    onError: () => {
      toaster.error("Something went wrong");
    },
  });
};

export const useAgentNotifyCounts = ({ isTrigger, isMobile, isMobileTrigger, tabChange }) => {
  const token = localStorage.getItem("token");
  return useQuery({
    queryKey: ["notification_category_count", tabChange],
    queryFn: () => {
      return getRequest(`/notification_category_count`);
    },
    // enabled: (!!token && (isTrigger || isMobileTrigger)),
    // staleTime: isMobile ? 1500 : 0
  });
};


export const useBanAppeal = () => {
  const toaster = useCustomToaster();
  return useMutation({
    mutationFn: (data) => {
      return postRequest(`/submit_ban_appeal`, { ...data });
    },
    onSuccess: (success) => {
      if (!success?.status) {
        toaster.error(success?.message);
      }
    },
    onError: () => {
      toaster.error("Something went wrong");
    },
  });
};


export const useNewsComments = () => {
  const toaster = useCustomToaster();
  return useMutation({
    mutationFn: (data) => {
      return postRequest(`/add_news_comment`, { ...data });
    },
    onSuccess: (success) => {
      if (!success?.status) {
        toaster.error(success?.message);
      }
      queryClient.invalidateQueries(["get_user_news_comments"])
    },
    onError: () => {
      toaster.error("Something went wrong");
    },
  });
};



export const useGetNewsFeed = (news_id) => {
  return useQuery({
    queryKey: ["get_user_news_comments", news_id],
    queryFn: () => {
      return getRequest(`/get_user_news_comments?news_id=${news_id}`);
    },
    enabled: !!news_id,
  });
};



export const useGetTempSingleNews = (news_id) => {
  return useQuery({
    queryKey: ["share_news", news_id],
    queryFn: () => {
      return getRequest(`/share_news?news_id=${news_id}`);
    },
    enabled: !!news_id,
  });
};



export const useReport = () => {
  const toaster = useCustomToaster();
  return useMutation({
    mutationFn: (data) => {
      return postRequest(`/report_content`, { ...data });
    },
    onSuccess: (success) => {
      console.log("🚀 ~ useReport ~ success:", success)
      if (!success?.status) {
        toaster.error(success?.message);
        return
      }
      toaster.success(success?.message)
      queryClient.invalidateQueries(["community"])
    },
    onError: () => {
      toaster.error("Something went wrong");
    },
  });
};

